import React, { useRef } from "react";
import { Dialog, DialogContent, DialogActions, Button } from "@mui/material";
import Webcam from "react-webcam";

const videoConstraints = {
  facingMode: "environment"
};

export default function CameraModal({ open, onClose, onCapture }) {
  const webcamRef = useRef(null);

  const handleCapture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    onCapture(imageSrc);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent>
        <Webcam
          audio={false}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          videoConstraints={videoConstraints}
          style={{ width: "100%" }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleCapture} variant="contained">Capture</Button>
      </DialogActions>
    </Dialog>
  );
}